import { isCboNivelSuperior } from 'types/NivelCbo'
import { isCboPodeRegistrarCid } from 'util/atendimento/cboHelper'

import { AntecedentesFamiliaresCiapFormModel } from './model-antecedentes'

export const canRegisterCid10Familiar = (cbo2002: string, isNivelSuperiorFlagEnabled: boolean): boolean =>
  isNivelSuperiorFlagEnabled ? isCboNivelSuperior(cbo2002) : isCboPodeRegistrarCid(cbo2002)

export const getBlockedCid10IdsForFamiliarRow = (
  formValues?: ReadonlyArray<AntecedentesFamiliaresCiapFormModel>,
  currentItemId?: ID,
  currentCiapId?: ID
): Set<ID> =>
  new Set(
    (formValues ?? [])
      .filter((item) => item._id !== currentItemId)
      .filter((item) => !currentCiapId || !item.ciap)
      .map((item) => item.cid10?.id)
      .filter((cid10Id): cid10Id is ID => !!cid10Id)
  )
